import { Html } from '@react-three/drei'
import { StyledMapLabel } from 'pages/siteView/siteMap/communalMapStyling/StyledMapLabel'
import React, { ReactNode } from 'react'
import { Vector3 } from 'three'

export const Label: React.FC<{
  body: ReactNode
  position?: Vector3
  name?: string
  visible: boolean
}> = ({ position, body, name, visible }) => {
  return (
    <group position={position}>
      <Html
        name={name}
        position={[0, 10, 0]}
        center
        style={{
          width: 0,
          height: 0,
          pointerEvents: 'none',
          display: visible ? undefined : 'none',
        }}>
        <div
          style={{
            position: 'relative',
            bottom: 50,
            left: -65,
            padding: 2,
            width: 130,
          }}>
          <StyledMapLabel>{body}</StyledMapLabel>
        </div>
      </Html>
    </group>
  )
}
